/* eslint-disable arrow-parens */
import { useHttpRequest } from "../useHttpRequest"

export const useRequest = () => {
  const loadAppConfig = options => useHttpRequest("panel.appConfig", options)

  const panelLogin = (options) => {
    return useHttpRequest("panel.panelLogin", options)
  }

  const verifyCode = (options) => {
    return useHttpRequest("panel.verifyCode", options)
  }

  const passwordLogin = options => useHttpRequest("panel.passwordLogin", options)

  const passwordRegister = options => useHttpRequest("panel.passwordRegister", options)

  const refreshToken = (options) => {
    return useHttpRequest("panel.refreshToken", options)
  }

  const getCompanyCategory = (options) => {
    return useHttpRequest("panel.companyCategory", options)
  }

  const supportRequest = (name, options) => useHttpRequest(`panel.${name}`, options)

  const createCompany = (options) => {
    return useHttpRequest("panel.createCompany", options)
  }

  const companySelect = (options) => {
    return useHttpRequest("panel.companySelect", options)
  }

  const companyAddFavorite = (options) => {
    return useHttpRequest("panel.companyAddFavorite", options)
  }

  const companyRemoveFavorite = (options) => {
    return useHttpRequest("panel.companyRemoveFavorite", options)
  }

  const companyUpdate = (options) => {
    return useHttpRequest("panel.companyUpdate", options)
  }

  const allCompaniesForEdit = (options) => {
    return useHttpRequest("panel.allCompaniesForEdit", options)
  }

  const saveMedia = (options) => {
    return useHttpRequest("panel.saveMedia", options)
  }

  const updateMedia = (options) => {
    return useHttpRequest("panel.updateMedia", options)
  }

  const deleteBlogMedia = (options) => {
    return useHttpRequest("panel.deleteBlogMedia", options)
  }

  const unitCreate = (options) => {
    return useHttpRequest("panel.unitCreate", options)
  }

  const allUnitsForEdit = (options) => {
    return useHttpRequest("panel.allUnitsForEdit", options)
  }

  const unitDelete = (options) => {
    return useHttpRequest("panel.unitDelete", options)
  }

  const unitSelect = (options) => {
    return useHttpRequest("panel.unitSelect", options)
  }

  const unitUpdate = (options) => {
    return useHttpRequest("panel.unitUpdate", options)
  }

  const bizServiceCreate = (options) => {
    return useHttpRequest("panel.bizServiceCreate", options)
  }

  const bizServiceSelectAll = (options) => {
    return useHttpRequest("panel.bizServiceSelectAll", options)
  }

  const bizServiceSelect = (options) => {
    return useHttpRequest("panel.bizServiceSelect", options)
  }

  const bizServiceFindByDefaultBizService = (options) => {
    return useHttpRequest("panel.bizServiceFindByDefaultBizService", options)
  }

  const loadClientBizServiceById = (options) => {
    return useHttpRequest("panel.loadClientBizServiceById", options)
  }

  const bizServiceAddFavorite = (options) => {
    return useHttpRequest("panel.bizServiceAddFavorite", options)
  }

  const bizServiceRemoveFavorite = (options) => {
    return useHttpRequest("panel.bizServiceRemoveFavorite", options)
  }

  const loadBizServiceCommentList = (options) => {
    return useHttpRequest("panel.loadBizServiceCommentList", options)
  }

  const bizServiceDelete = (options) => {
    return useHttpRequest("panel.bizServiceDelete", options)
  }

  const bizServiceUpdate = (options) => {
    return useHttpRequest("panel.bizServiceUpdate", options)
  }

  const allUnitsForEditBizService = (options) => {
    return useHttpRequest("panel.allUnitsForEditBizService", options)
  }

  const unitSaveMedia = (options) => {
    return useHttpRequest("panel.unitSaveMedia", options)
  }

  const unitUpdateMedia = (options) => {
    return useHttpRequest("panel.unitUpdateMedia", options)
  }

  const bizServiceSaveMedia = (options) => {
    return useHttpRequest("panel.bizServiceSaveMedia", options)
  }

  const bizServiceUpdateMedia = (options) => {
    return useHttpRequest("panel.bizServiceUpdateMedia", options)
  }

  const loadAllActiveServiceForDiscountEdit = (options) => {
    return useHttpRequest("panel.loadAllActiveServiceForDiscountEdit", options)
  }

  const discountCreate = (options) => {
    return useHttpRequest("panel.discountCreate", options)
  }

  const loadAllDiscountByBizService = (options) => {
    return useHttpRequest("panel.loadAllDiscountByBizService", options)
  }

  const discountDelete = (options) => {
    return useHttpRequest("panel.discountDelete", options)
  }

  const generateUnitReserveTime = (options) => {
    return useHttpRequest("panel.generateUnitReserveTime", options)
  }

  const loadUnitAllReserveTime = (options) => {
    return useHttpRequest("panel.loadUnitAllReserveTime", options)
  }

  const loadUnitAvailabilityCalendar = options => useHttpRequest("panel.loadUnitAvailabilityCalendar", options)
  const loadUnitAvailabilityDay = options => useHttpRequest("panel.loadUnitAvailabilityDay", options)
  const loadClientUnitAllReserveTime = (options) => {
    return useHttpRequest("panel.loadClientUnitAllReserveTime", options)
  }

  const loadUserByMobileNumber = (options) => {
    return useHttpRequest("panel.loadUserByMobileNumber", options)
  }

  const loadCurrentUserProfile = options => useHttpRequest("panel.loadCurrentUserProfile", options)

  const setInitialPassword = options => useHttpRequest("panel.setInitialPassword", options)

  const changePassword = options => useHttpRequest("panel.changePassword", options)

  const findOrCreateTemporaryUser = (options) => {
    return useHttpRequest("panel.findOrCreateTemporaryUser", options)
  }

  const preRegisterReserveTimeByUnitAdmin = (options) => {
    return useHttpRequest("panel.preRegisterReserveTimeByUnitAdmin", options)
  }

  const registerReserveTimeByUnitAdmin = (options) => {
    return useHttpRequest("panel.registerReserveTimeByUnitAdmin", options)
  }

  const loadReserveTimeByAdminUnit = (options) => {
    return useHttpRequest("panel.loadReserveTimeByAdminUnit", options)
  }

  const cancelReserveTimeByUnitAdmin = (options) => {
    return useHttpRequest("panel.cancelReserveTimeByUnitAdmin", options)
  }

  const cancelReserveTimeByClient = (options) => {
    return useHttpRequest("panel.cancelReserveTimeByClient", options)
  }

  const inActiveUnitReserveTime = (options) => {
    return useHttpRequest("panel.inActiveUnitReserveTime", options)
  }

  const cancelUnitAllReservedTime = (options) => {
    return useHttpRequest("panel.cancelUnitAllReservedTime", options)
  }

  const reserveTimeAdvancedSearch = (options) => {
    return useHttpRequest("panel.reserveTimeAdvancedSearch", options)
  }

  const unitAdminCreate = (options) => {
    return useHttpRequest("panel.unitAdminCreate", options)
  }

  const teamOverview = options => useHttpRequest("panel.teamOverview", options)
  const teamLookup = options => useHttpRequest("panel.teamLookup", options)
  const teamAdd = options => useHttpRequest("panel.teamAdd", options)
  const teamRemove = options => useHttpRequest("panel.teamRemove", options)
  const companyAdminCreate = (options) => {
    return useHttpRequest("panel.companyAdminCreate", options)
  }

  const unitAdminSelectByCompany = (options) => {
    return useHttpRequest("panel.unitAdminSelectByCompany", options)
  }

  const companyAdminSelectByCompany = (options) => {
    return useHttpRequest("panel.companyAdminSelectByCompany", options)
  }

  const companyAdminDelete = (options) => {
    return useHttpRequest("panel.companyAdminDelete", options)
  }

  const unitAdminDelete = (options) => {
    return useHttpRequest("panel.unitAdminDelete", options)
  }

  const loadHomeNearestCompanies = (options) => {
    return useHttpRequest("panel.loadHomeNearestCompanies", options)
  }

  const clientSearchSuggestions = (options) => {
    return useHttpRequest("panel.clientSearchSuggestions", options)
  }

  const clientSearch = (options) => {
    return useHttpRequest("panel.clientSearch", options)
  }

  const loadHomeSpecialCompanies = (options) => {
    return useHttpRequest("panel.loadHomeSpecialCompanies", options)
  }

  const loadHomeDiscountList = (options) => {
    return useHttpRequest("panel.loadHomeDiscountList", options)
  }

  const loadHomeSpecialServices = (options) => {
    return useHttpRequest("panel.loadHomeSpecialServices", options)
  }

  const loadFavoriteServices = (options) => {
    return useHttpRequest("panel.loadFavoriteServices", options)
  }

  const loadFavoriteCompanies = (options) => {
    return useHttpRequest("panel.loadFavoriteCompanies", options)
  }

  const defaultBizServiceLoadByCategoryId = (options) => {
    return useHttpRequest("panel.defaultBizServiceLoadByCategoryId", options)
  }

  const loadHomeCompanies = (options) => {
    return useHttpRequest("panel.loadHomeCompanies", options)
  }

  const defaultBizServiceLoadByCategoryIdList = (options) => {
    return useHttpRequest(
      "panel.defaultBizServiceLoadByCategoryIdList",
      options
    )
  }

  const loadFilterItem = () => {
    return useHttpRequest("panel.loadFilterItem")
  }

  const preRegisterReserveTimeByClient = (options) => {
    return useHttpRequest("panel.preRegisterReserveTimeByClient", options)
  }

  const registerReserveTime = (options) => {
    return useHttpRequest("panel.registerReserveTime", options)
  }

  const loadAdminReserveTimeListForDetermine = (options) => {
    return useHttpRequest("panel.loadAdminReserveTimeListForDetermine", options)
  }

  const loadUserReserveTime = (options) => {
    return useHttpRequest("panel.loadUserReserveTime", options)
  }

  const setReserveTimeUsed = (options) => {
    return useHttpRequest("panel.setReserveTimeUsed", options)
  }

  const addAdminRateToReserveTime = (options) => {
    return useHttpRequest("panel.addAdminRateToReserveTime", options)
  }

  const addClientComment = (options) => {
    return useHttpRequest("panel.addClientComment", options)
  }

  const loadClientReserveTimeComment = (options) => {
    return useHttpRequest("panel.loadClientReserveTimeComment", options)
  }

  const loadAdminUnitCommentListForReply = (options) => {
    return useHttpRequest("panel.loadAdminUnitCommentListForReply", options)
  }

  const addAdminCommentReply = (options) => {
    return useHttpRequest("panel.addAdminCommentReply", options)
  }

  const loadCompanyCommentList = (options) => {
    return useHttpRequest("panel.loadCompanyCommentList", options)
  }

  const blogLoadByType = (options) => {
    return useHttpRequest("panel.blogLoadByType", options)
  }

  const blogLoadPopular = (options) => {
    return useHttpRequest("panel.blogLoadPopular", options)
  }

  const registerBlogPostView = (options) => {
    return useHttpRequest("panel.registerBlogPostView", options)
  }

  const blogCreate = (options) => {
    return useHttpRequest("panel.blogCreate", options)
  }

  const deleteBlogPost = (options) => {
    return useHttpRequest("panel.deleteBlogPost", options)
  }

  const createBlogPostComment = (options) => {
    return useHttpRequest("panel.createBlogPostComment", options)
  }

  const createBlogPostCommentReply = (options) => {
    return useHttpRequest("panel.createBlogPostCommentReply", options)
  }

  const loadBlogPostCommentList = (options) => {
    return useHttpRequest("panel.loadBlogPostCommentList", options)
  }

  const loadBlogPostCommentReplyList = (options) => {
    return useHttpRequest("panel.loadBlogPostCommentReplyList", options)
  }

  return {
    loadAppConfig,
    panelLogin,
    verifyCode,
    passwordLogin,
    passwordRegister,
    refreshToken,
    getCompanyCategory,
    supportCompanyModeration: options => supportRequest("supportCompanyModeration", options),
    supportCompanyApprove: options => supportRequest("supportCompanyApprove", options),
    supportCompanyReject: options => supportRequest("supportCompanyReject", options),
    supportCompanyStatus: options => supportRequest("supportCompanyStatus", options),
    supportBlogModeration: options => supportRequest("supportBlogModeration", options),
    supportBlogStatus: options => supportRequest("supportBlogStatus", options),
    supportMediaModeration: options => supportRequest("supportMediaModeration", options),
    supportMediaStatus: options => supportRequest("supportMediaStatus", options),
    supportModerationHistory: options => supportRequest("supportModerationHistory", options),
    blogLoadByTypeForAdmin: options => supportRequest("blogLoadByTypeForAdmin", options),
    supportCategoryCreate: options => supportRequest("supportCategoryCreate", options),
    supportCategoryUpdate: options => supportRequest("supportCategoryUpdate", options),
    supportCategoryManagement: options => supportRequest("supportCategoryManagement", options),
    supportCategoryDelete: options => supportRequest("supportCategoryDelete", options),
    supportDefaultServiceCreate: options => supportRequest("supportDefaultServiceCreate", options),
    supportDefaultServiceUpdate: options => supportRequest("supportDefaultServiceUpdate", options),
    supportDefaultServiceDelete: options => supportRequest("supportDefaultServiceDelete", options),
    supportCalendarGenerate: options => supportRequest("supportCalendarGenerate", options),
    supportCalendarRange: options => supportRequest("supportCalendarRange", options),
    supportCalendarUpdate: options => supportRequest("supportCalendarUpdate", options),
    businessReportDashboard: options => supportRequest("businessReportDashboard", options),
    siteReportDashboard: options => supportRequest("siteReportDashboard", options),
    businessReportAppointments: options => supportRequest("businessReportAppointments", options),
    businessReportCustomers: options => supportRequest("businessReportCustomers", options),
    businessReportServices: options => supportRequest("businessReportServices", options),
    businessReportFinance: options => supportRequest("businessReportFinance", options),
    businessReportCapacity: options => supportRequest("businessReportCapacity", options),
    siteReportAppointments: options => supportRequest("siteReportAppointments", options),
    siteReportUsers: options => supportRequest("siteReportUsers", options),
    siteReportCompanies: options => supportRequest("siteReportCompanies", options),
    siteReportFinance: options => supportRequest("siteReportFinance", options),
    siteReportCategories: options => supportRequest("siteReportCategories", options),
    siteReportGeographies: options => supportRequest("siteReportGeographies", options),
    siteReportModeration: options => supportRequest("siteReportModeration", options),
    createCompany,
    companySelect,
    companyAddFavorite,
    companyRemoveFavorite,
    companyUpdate,
    allCompaniesForEdit,
    saveMedia,
    updateMedia,
    deleteBlogMedia,
    unitCreate,
    allUnitsForEdit,
    allUnitsForEditBizService,
    unitDelete,
    unitSelect,
    unitUpdate,
    unitSaveMedia,
    unitUpdateMedia,
    bizServiceCreate,
    bizServiceSelectAll,
    bizServiceSelect,
    bizServiceFindByDefaultBizService,
    loadClientBizServiceById,
    bizServiceAddFavorite,
    bizServiceRemoveFavorite,
    loadBizServiceCommentList,
    bizServiceDelete,
    bizServiceUpdate,
    bizServiceSaveMedia,
    bizServiceUpdateMedia,
    loadAllActiveServiceForDiscountEdit,
    discountCreate,
    loadAllDiscountByBizService,
    discountDelete,
    generateUnitReserveTime,
    loadUnitAllReserveTime,
    loadUnitAvailabilityCalendar,
    loadUnitAvailabilityDay,
    loadClientUnitAllReserveTime,
    loadUserByMobileNumber,
    loadCurrentUserProfile,
    setInitialPassword,
    changePassword,
    findOrCreateTemporaryUser,
    preRegisterReserveTimeByUnitAdmin,
    registerReserveTimeByUnitAdmin,
    loadReserveTimeByAdminUnit,
    cancelReserveTimeByUnitAdmin,
    cancelReserveTimeByClient,
    inActiveUnitReserveTime,
    cancelUnitAllReservedTime,
    reserveTimeAdvancedSearch,
    unitAdminCreate,
    teamOverview, teamLookup, teamAdd, teamRemove,
    companyAdminCreate,
    unitAdminSelectByCompany,
    companyAdminSelectByCompany,
    companyAdminDelete,
    unitAdminDelete,
    loadHomeNearestCompanies,
    clientSearchSuggestions,
    clientSearch,
    loadHomeSpecialCompanies,
    loadHomeDiscountList,
    loadHomeSpecialServices,
    loadFavoriteServices,
    loadFavoriteCompanies,
    defaultBizServiceLoadByCategoryId,
    loadHomeCompanies,
    defaultBizServiceLoadByCategoryIdList,
    loadFilterItem,
    preRegisterReserveTimeByClient,
    registerReserveTime,
    loadAdminReserveTimeListForDetermine,
    loadUserReserveTime,
    setReserveTimeUsed,
    addAdminRateToReserveTime,
    addClientComment,
    loadClientReserveTimeComment,
    loadAdminUnitCommentListForReply,
    addAdminCommentReply,
    loadCompanyCommentList,
    blogLoadByType,
    blogLoadPopular,
    registerBlogPostView,
    blogCreate,
    deleteBlogPost,
    createBlogPostComment,
    createBlogPostCommentReply,
    loadBlogPostCommentList,
    loadBlogPostCommentReplyList,
  }
}
